<div class="img-editor-wrapper">

  <!-- ── AMBIENT GLOW ──────────────────────────────────────────────── -->
  <div class="ambient-glow"></div>

  <!-- ── HEADER GLASSMORPHISM ──────────────────────────────────────── -->
  <div class="editor-header">
    <div class="editor-header-left">
      <div class="editor-icon-wrap">
        <ion-icon name="construct-outline"></ion-icon>
      </div>
      <div class="editor-header-texts">
        <span class="editor-title">Editor de Medidas</span>
        <span class="editor-subtitle">Dibujo y anotación técnica</span>
      </div>
    </div>
    <button class="editor-close-btn" (click)="close()" aria-label="Cerrar">
      <ion-icon name="close"></ion-icon>
    </button>
  </div>

  <!-- ── CANVAS ────────────────────────────────────────────────────── -->
  <div class="canvas-area">
    <div class="canvas-container" #canvasContainer>
      <canvas #canvas></canvas>
    </div>
  </div>

  <!-- ── TOOLS PANEL GLASSMORPHISM ─────────────────────────────────── -->
  <div class="tools-panel">
    <!-- Segment: Línea / Texto -->
    <div class="tools-segment-wrap">
      <ion-segment [(ngModel)]="mode" (ionChange)="modeChanged()" mode="ios" class="editor-segment">
        <ion-segment-button value="line">
          <ion-icon name="resize-outline"></ion-icon>
          <ion-label>Línea</ion-label>
        </ion-segment-button>
        <ion-segment-button value="text">
          <ion-icon name="text-outline"></ion-icon>
          <ion-label>Texto</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>

    <!-- Paleta de colores -->
    <div class="color-palette">
      <div class="color-dot" [class.selected]="currentColor === '#FF0000'" (click)="setColor('#FF0000')">
        <div class="dot-inner" [style.background]="'#FF0000'"></div>
      </div>
      <div class="color-dot" [class.selected]="currentColor === '#000000'" (click)="setColor('#000000')">
        <div class="dot-inner" [style.background]="'#000000'"></div>
      </div>
      <div class="color-dot" [class.selected]="currentColor === '#FFFFFF'" (click)="setColor('#FFFFFF')">
        <div class="dot-inner" [style.background]="'#FFFFFF'"></div>
      </div>
      <div class="color-dot" [class.selected]="currentColor === '#FFFF00'" (click)="setColor('#FFFF00')">
        <div class="dot-inner" [style.background]="'#FFFF00'"></div>
      </div>
      <div class="color-dot" [class.selected]="currentColor === '#5b8af5'" (click)="setColor('#5b8af5')">
        <div class="dot-inner" [style.background]="'#5b8af5'"></div>
      </div>
    </div>

    <!-- Acciones -->
    <div class="tools-actions">
      <!-- Editar texto seleccionado -->
      <button class="tool-action-btn edit"
              *ngIf="selectedElementIndex !== -1 && elements[selectedElementIndex].type === 'text'"
              (click)="editSelected()">
        <ion-icon name="create-outline"></ion-icon>
      </button>
      <!-- Eliminar seleccionado -->
      <button class="tool-action-btn delete" *ngIf="selectedElementIndex !== -1"
              (click)="deleteSelected()">
        <ion-icon name="trash-outline"></ion-icon>
      </button>

      <div class="tools-divider" *ngIf="selectedElementIndex !== -1"></div>

      <!-- Deshacer -->
      <button class="tool-action-btn undo" (click)="undo()">
        <ion-icon name="arrow-undo-outline"></ion-icon>
      </button>
      <!-- Limpiar todo -->
      <button class="tool-action-btn clear" (click)="clear()">
        <ion-icon name="trash-bin-outline"></ion-icon>
      </button>
    </div>
  </div>

  <!-- ── TEXT INPUT OVERLAY GLASSMORPHISM ──────────────────────────── -->
  <div *ngIf="mode === 'text'" class="text-input-overlay">
    <div class="text-input-glass">
      <ion-icon name="pencil-outline" class="input-prefix-icon"></ion-icon>
      <ion-input #textInput [(ngModel)]="textVal" placeholder="Ingresar medida..."
                  (keyup.enter)="addText()" class="glass-text-input" mode="ios"></ion-input>
      <button class="text-ok-btn" (click)="addText()">
        <ion-icon name="checkmark"></ion-icon>
      </button>
    </div>
  </div>

  <!-- ── FOOTER ────────────────────────────────────────────────────── -->
  <div class="editor-footer">
    <button class="save-btn" (click)="save()">
      <ion-icon name="save-outline"></ion-icon>
      <span>Guardar Cambios</span>
    </button>
  </div>

</div>
